import VIcon from './VIcon'

/* istanbul ignore next */
VIcon.install = function install (Vue) {
  Vue.component(VIcon.name, VIcon)
}

export default VIcon



// WEBPACK FOOTER //
// ./src/components/VIcon/index.js